import { AuthState } from "../appinitandstate/AuthState";
import { Permission, permissionsToRequest } from "./Permission";
import { LocalStorageKey } from "../localStoragePersistence/common/LocalStorageKey";
import { NavigateFunction } from "react-router-dom";

/** which screen of the Auth0 Universal Login to open */
export type LoginScreen = "login" | "signup";

export default abstract class Auth {
  protected static readonly grantedPermissionsStringLocalStorageKey =
    new LocalStorageKey("AuthGrantedPermissionsString", undefined);

  abstract login(navigate: NavigateFunction, screen?: LoginScreen): void;

  abstract handleAuthentication(): Promise<AuthState>;

  abstract getAccessToken(): undefined | string;

  abstract getIdToken(): undefined | string;

  // Defines the timestamp after which the token should be refreshed.
  abstract getRefreshTokenAfter(): number | undefined;

  abstract renewSession(
    resultCallback: (authenticationResult: AuthState) => void,
  ): void;

  abstract logout(navigate: NavigateFunction): void;

  abstract isAuthenticated(): boolean;

  canAttemptSessionRenewal(): boolean {
    return false;
  }

  protected abstract getGrantedPermissionsString(): string | undefined;

  getPermissionOverview(): readonly {
    permission: Permission;
    granted: boolean;
  }[] {
    const grantedPermissionsString = this.getGrantedPermissionsString();
    return permissionsToRequest.map((requestedPermission) => ({
      permission: requestedPermission,
      granted: grantedPermissionsString
        ? grantedPermissionsString.includes(requestedPermission.name)
        : false,
    }));
  }

  hasPermissions(requiredPermissions: readonly Permission[]): boolean {
    return requiredPermissions.every((required) =>
      this.getGrantedPermissionsString()?.includes(required.name),
    );
  }

  abstract getEmail(): string | undefined;

  abstract getAuth0Subject(): string;
}
